import { Card, DatePicker } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import React, { createContext, useContext, useEffect, useState } from "react";
import { SettingContext } from "../../routes";
import CustomHeader from "../common/Header";
import { Chart1 } from "./Chart1";
import { Chart2 } from "./Chart2";
import { Chart3 } from "./Chart3";
import { Chart4 } from "./Chart4";
import { Chart5 } from "./Chart5";
import { dateRangePresets } from "../../services/util";
dayjs.extend(customParseFormat);

const { RangePicker } = DatePicker;
const HKAnalyticsContext = createContext();

function HKAnalytics() {
    const { setSelectedHotelType } = useContext(SettingContext);

    const [selectedDates, setSelectedDates] = useState([
        dayjs()
            .subtract(7, "days")
            .startOf("day")
            .format("YYYY/MM/DD HH:MM:SS"),
        dayjs()
            .subtract(1, "days")
            .startOf("day")
            .format("YYYY/MM/DD HH:MM:SS"),
    ]);

    useEffect(() => {
        setSelectedHotelType("operation");
        return () => {
            setSelectedHotelType("all");
        };
    }, []);

    function handleDateChange(e) {
        let start_date =
            e !== null ? dayjs(e[0]).startOf("day") : selectedDates[0];
        let end_date =
            e !== null ? dayjs(e[1]).startOf("day") : selectedDates[1];

        // set the default value if null
        setSelectedDates([start_date, end_date]);
    }

    function disableFutureDates(current) {
        return current && current > dayjs().startOf("day");
    }

    return (
        <HKAnalyticsContext.Provider
            value={{ selectedDates, setSelectedDates }}
        >
            <CustomHeader
                extraAfter={
                    <RangePicker
                        allowClear={false}
                        disabledDate={disableFutureDates}
                        defaultValue={[
                            dayjs(selectedDates[0]),
                            dayjs(selectedDates[1]),
                        ]}
                        value={[
                            dayjs(selectedDates[0]),
                            dayjs(selectedDates[1]),
                        ]}
                        className="dashboard-date-search"
                        onChange={handleDateChange}
                        format="MM/DD/YYYY"
                        presets={dateRangePresets.filter(
                            (preset) => preset.label !== "Today",
                        )}
                    />
                }
            />
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    flexDirection: "column",
                }}
            >
                <Card className="margin-5" hoverable>
                    <Chart1 />
                </Card>
                <Card className="margin-5" hoverable>
                    <Chart2 />
                </Card>
                <Card className="margin-5" hoverable>
                    <Chart3 />
                </Card>
                <Card className="margin-5" hoverable>
                    <Chart4 />
                </Card>
                <Card className="margin-5" hoverable>
                    <Chart5 />
                </Card>
            </div>
        </HKAnalyticsContext.Provider>
    );
}

export { HKAnalytics, HKAnalyticsContext };
